<template>
  <div :class="b()">
    <p :class="b('description')">
      {{ $t('c-software-versions.description') }}
    </p>
    <div :class="b('table-wrapper')">
      <table :class="b('table')">
        <thead>
          <tr :class="b('table-row')">
            <th
              v-for="column in tableColumns"
              :key="column.label"
              :class="b('table-head', { bigger: column.bigger })"
            >
              {{ column.label }}
            </th>
          </tr>
        </thead>
        <tbody :class="b('table-body')">
          <tr
            v-for="(software, idx) in softwareVersions"
            :key="idx"
            :class="b('table-row')"
          >
            <td :class="b('table-detail', { underline: true })">
              <a
                :href="software.downloadUrl"
                download
              >
                {{ getName(software) }}
              </a>
            </td>
            <td :class="b('table-detail')">
              {{ software.version }}
            </td>
            <td :class="b('table-detail')">{{ software.releaseDate }}</td>
            <td :class="b('table-detail', { underline: true })">
              <a
                v-if="software.releaseNotesUrl"
                :href="software.releaseNotesUrl"
                :target="software.releaseNotesTarget"
              >
                {{ $t('c-software-versions.read-more') }}
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script lang="ts">
  import { PropType, defineComponent } from 'vue';
  import { SoftwareVersion } from '@/types/product';

  // type Setup = {}
  type Data = {
    tableColumns: { label: string; bigger: boolean }[];
  };

  /**
   * Display a list of software version downloads
   */
  export default defineComponent({
    name: 'c-software-versions',

    // components: {},

    props: {
      /**
       * The software versions to display
       */
      softwareVersions: {
        type: Array as PropType<SoftwareVersion[] | null>,
        default: () => [],
      },
    },
    // emits: {},

    // setup(): Setup {},
    data(): Data {
      return {
        tableColumns: [
          { label: this.$t('c-software-versions.table-columns.name'), bigger: false },
          { label: this.$t('c-software-versions.table-columns.version'), bigger: false },
          { label: this.$t('c-software-versions.table-columns.release-date'), bigger: true },
          { label: this.$t('c-software-versions.table-columns.release-notes'), bigger: true },
        ],
      };
    },

    // computed: {},
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    methods: {
      getName(softwareVersion: SoftwareVersion): string {
        return softwareVersion.name.split('/').pop() || '';
      },
    },
    // render() {},
  });
</script>

<style lang="scss">
  @use '@/setup/scss/variables';
  @use '@/setup/scss/mixins';

  .c-software-versions {
    &__description {
      margin-bottom: 2.5rem;
    }

    &__table-wrapper {
      overflow-x: auto;
    }

    &__table {
      width: 100%;
    }

    &__table-head {
      background-color: var(--theme-color-grayscale--850);
      padding: variables.$va-spacing--10;
      font-weight: variables.$va-font-weight--bold;
      min-width: 6rem;

      &--bigger {
        min-width: 8.125rem;
      }
    }

    &__table-row {
      border-bottom: 0.5px solid var(--theme-color-grayscale--800);
    }

    &__table-detail {
      @include mixins.hyphens;

      padding: variables.$va-spacing--10;

      &--underline {
        text-decoration: underline;
      }
    }
  }
</style>
